/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DoneIcon from '@mui/icons-material/Done';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { StatCardV2 } from '../../../components/v2';
import TableService from '../../../services/TableService';

const STATUS_CONFIG = [
  {
    key: 'AGUARDANDO_VALIDACAO',
    label: 'Aguardando Validação',
    color: 'info',
    icon: <InfoIcon />,
  },
  {
    key: 'VALIDADO',
    label: 'Validado',
    color: 'success',
    icon: <DoneIcon />,
  },
  {
    key: 'INVALIDADO',
    label: 'Invalidado',
    color: 'error',
    icon: <ReportProblemIcon />,
  },
  {
    key: 'RESTRICAO_AREA',
    label: 'Restrição de Área',
    color: 'warning',
    icon: <ReportProblemIcon />,
  },
];

const ResumoCards = ({ apiFilter, activeStatus, onFilterByStatus }) => {
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchCounts = useCallback(async () => {
    setLoading(true);

    try {
      const response = await TableService.request('pedidos-voo/resumo', apiFilter);
      setCounts(response?.data || {});
    } catch {
      setCounts({});
    } finally {
      setLoading(false);
    }
  }, [apiFilter]);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  return (
    <Grid container spacing={2}>
      {STATUS_CONFIG.map((config) => (
        <Grid key={config.key} size={{ xs: 6, sm: 3 }}>
          <StatCardV2
            label={config.label}
            value={counts[config.key]}
            icon={config.icon}
            color={config.color}
            loading={loading}
            active={activeStatus === config.key}
            onClick={() =>
              onFilterByStatus(activeStatus === config.key ? null : config.key)
            }
          />
        </Grid>
      ))}
    </Grid>
  );
};

ResumoCards.propTypes = {
  apiFilter: PropTypes.object.isRequired,
  activeStatus: PropTypes.string,
  onFilterByStatus: PropTypes.func.isRequired,
};

ResumoCards.defaultProps = {
  activeStatus: null,
};

export default ResumoCards;
